import IntroView from './intro/IntroView'
import QuestionView from './question/QuestionView'
import SummaryView from './summary/SummaryView'
import FooterView from './footer/FooterView'

const Views = {
  IntroView,
  SummaryView,
  QuestionView,
  FooterView,
}

export default Views
